import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { SignUpLink } from '../registration/SignUp';
import { withFirebase } from '../../components/Firebase';

import { Link } from 'react-router-dom'
import { PasswordForgetLink } from '../registration/PasswordForget';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import ListGroup from 'react-bootstrap/ListGroup'
import Tab from 'react-bootstrap/Tab'
import styled from 'styled-components'




const Styles = styled.div`

  .password-conflict {
    color: red;
  }

  .link {
      justify-content: center;
  }

  .absolute {
    position: absolute;
    bottom: 10px;
    width: 50%;
    border: 3px solid #8AC007;
    color: red;
  }

`;

const SignInPage = () => (
    <Styles>
        <div className="link">
            <h1>SignIn</h1>
            <SignInForm />
            <PasswordForgetLink />
        </div>
    </Styles>

);

const INITIAL_STATE = {
    email: '',
    password: '',
    error: null,
};


class SignInFormBase extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE, hasAccount: false };
    }


    onSubmit = event => {
        const { email, password } = this.state;

        this.props.firebase
            .doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState({ ...INITIAL_STATE });
            })
            .catch(error => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { email, password, error } = this.state;
        const isInvalid = password === '' || email === '';

        const hasAccount = this.state.hasAccount

        return (
            <Styles>
                <Tab.Container id="list-group-tabs-example" defaultActiveKey="#Existing">
                    <Row>
                        <Col sm={3}>
                            <ListGroup>
                                <ListGroup.Item action href="#Existing">
                                    Log in
        </ListGroup.Item>
                                <ListGroup.Item action href="#Guest">
                                    Guest
                                            </ListGroup.Item>
                                <Link to={{
                                    pathname: "/email",
                                    data: {
                                    }
                                }}>
                                    <ListGroup.Item >
                                        Create Account
    </ListGroup.Item>
                                </Link>
                            </ListGroup>
                        </Col>
                        <Col sm={8}>
                            <Tab.Content>
                                <Tab.Pane eventKey="#Existing">
                                    <Form onSubmit={this.onSubmit}>
                                        <Form.Label>Email address</Form.Label>
                                        <Form.Control type="text" name="email" value={email} onChange={this.onChange} placeholder="Enter email" />

                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" name="password" value={password} onChange={this.onChange} placeholder="Enter password" />

                                        <Button disabled={isInvalid} type="submit">
                                            Sign In
        </Button>
                                        {error && <p>{error.message}</p>}
                                    </Form>
                                </Tab.Pane>
                                <Tab.Pane eventKey="#Guest">
                                    <Form onSubmit={this.onSubmit}>

                                        <Form.Label>Email address</Form.Label>
                                        <Form.Control type="text" name="email" value={email} onChange={this.onChange} placeholder="Enter email" />
                                        {error && <p>{error.message}</p>}
                                    </Form>
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Styles>

        );
    }
}


const SignInForm = compose(
    withRouter,
    withFirebase,
)(SignInFormBase);


export default SignInPage;
export { SignInForm };